import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=ea0a3448&scoped=true"
import script from "./distribution.vue?vue&type=script&lang=ts"
export * from "./distribution.vue?vue&type=script&lang=ts"
import style0 from "./distribution.vue?vue&type=style&index=0&id=ea0a3448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a3448",
  null
  
)

export default component.exports